import React from 'react';
import { Translate } from 'core/translate';

const Pager = ({
  images,
  index,
  analyticsKey,
  onChangeIndex,
  baseClassName
}) => {
  const items = images.map((image, currentIndex) => {
    const isActive = currentIndex === index;
    return (
      <button
        key={image.url}
        type="button"
        className={`${baseClassName}__dot stat-dots ${
          isActive ? `${baseClassName}__dot--active` : ''
        }`}
        onClick={() => onChangeIndex(currentIndex)}
        data-dtm={analyticsKey}>
        <span className="show-for-sr">
          <Translate
            value="component.cgi.meatball.label"
            index={currentIndex + 1}
            total={images.length}
          />
        </span>
      </button>
    );
  });

  return (
    <div
      className={`${baseClassName}__pager ${
        images.length > 1 ? '' : 'invisible'
      }`}>
      {items}
    </div>
  );
};

export default Pager;
